import { render, staticRenderFns } from "./RoomDetails.vue?vue&type=template&id=4b622f5b&scoped=true&"
import script from "./RoomDetails.vue?vue&type=script&lang=js&"
export * from "./RoomDetails.vue?vue&type=script&lang=js&"
import style0 from "./RoomDetails.vue?vue&type=style&index=0&id=4b622f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b622f5b",
  null
  
)

export default component.exports